import { render, staticRenderFns } from "./VirtuallobbyImageHotspot.vue?vue&type=template&id=8b7e0e5a&scoped=true&"
import script from "./VirtuallobbyImageHotspot.vue?vue&type=script&lang=js&"
export * from "./VirtuallobbyImageHotspot.vue?vue&type=script&lang=js&"
import style0 from "./VirtuallobbyImageHotspot.vue?vue&type=style&index=0&id=8b7e0e5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7e0e5a",
  null
  
)

export default component.exports